export default class BackofficeStudyRequestsShow {
  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    $(".study-request-author-edit").on('click', event => {
      const authorFormUrl = $(event.currentTarget).data('author-form-url');
      this.launchStudyRequestAuthorEditModal(authorFormUrl);
    });

    $("#study-request-author-form-submit").on('click', event => {
      this.submitStudyRequestAuthorForm();
    });

    // Clean up Select2 when modal is closed
    $('#study-request-author-edit-modal').on('hidden.bs.modal', () => {
      this.destroySelect2();
    });
  }

  onDataChanged(data) {
  }

  onDestroy() {
  }

  launchStudyRequestAuthorEditModal(authorFormUrl) {
    $.ajax({
      url: authorFormUrl,
      type: "GET",
      success: (data) => {
        $("#study-request-author-edit-modal-body").html(data);
        
        // Initialize Select2 after the content is loaded
        this.initializeSelect2();
        
        $("#study-request-author-edit-modal").modal("show");
      },
      error: (xhr) => {
        console.error("Error loading study request author edit form:", xhr);
      }
    });
  }

  submitStudyRequestAuthorForm() {
    console.log("submitStudyRequestAuthorForm");
    let form = $("#study-request-author-form");
    const studyRequestId = form.find('input[name="study_request[id]"]').val();
    const updateUrl = $("#author-update-url").data('update-url');
    
    $.ajax({
      url: updateUrl,
      type: form.attr('method'),
      data: form.serialize(),
      success: (response) => {
        if (response.success) {
          // Get the original button's data attributes to preserve the URL
          const originalButton = $(".study-request-author-edit");
          const authorFormUrl = originalButton.data('author-form-url');
          
          // Update the UI with the new author information
          $("#summary_study_request_author").html(
            response.new_author + " (" + response.entity_name + ")" +
            '<button class="btn btn-sm btn-outline-primary ml-2 study-request-author-edit" ' +
            'data-study-request="' + studyRequestId + '" ' +
            'data-author-form-url="' + authorFormUrl + '">' +
            '<i class="ri-pencil-line"></i> Modifier</button>'
          );
          
          // Close the modal
          $("#study-request-author-edit-modal").modal("hide");
          
          // Show success notification
          application.successNotification("Auteur mis à jour avec succès");
          
          // Rebind events for the new button
          this.bindAuthorEditEvent();
        }
      },
      error: (xhr) => {
        let errorMessage = "Erreur lors de la mise à jour";
        if (xhr.responseJSON && xhr.responseJSON.error) {
          errorMessage = xhr.responseJSON.error;
        }
        application.errorNotification("Erreur lors de la mise à jour de l'auteur");
      }
    });
  }

  bindAuthorEditEvent() {
    $(".study-request-author-edit").off('click').on('click', event => {
      const authorFormUrl = $(event.currentTarget).data('author-form-url');
      this.launchStudyRequestAuthorEditModal(authorFormUrl);
    });
  }

  initializeSelect2() {
    // Initialize Select2 on the author select dropdown
    $('.select2-author-select').select2({
      placeholder: "Rechercher un client...",
      width: '100%',
      dropdownParent: $('#study-request-author-edit-modal'), // Ensure dropdown appears within modal
      language: {
        noResults: function() {
          return "Aucun client trouvé";
        },
        searching: function() {
          return "Recherche en cours...";
        }
      }
    });
  }

  // Clean up Select2 when modal is closed to prevent memory leaks
  destroySelect2() {
    if ($('.select2-author-select').hasClass('select2-hidden-accessible')) {
      $('.select2-author-select').select2('destroy');
    }
  }
}